import React, { useEffect, useState } from "react";
import { useStepsStore } from "../../stores/StepsStore";

function PaymentOptionSelector({ selectedVariantId }: { selectedVariantId: number | null }) {
  const [selected, setSelected] = useState<'annually' | 'monthly'>("annually");
  const handleToggle = (option: any) => {
    setSelected(option);
  };

  const [vatExempt, setVatExempt] = useState(false);
  const [planDisocunt, setPlanDiscount] = useState(0);
  const [planPrice, setPlanPrice] = useState<{ monthly: number; annual: number; }>({ monthly: 0, annual: 0});

  const { vat_plans, no_vat_plans, setSelectedVariantId, newCustomerForm, setSubscriptionPrice, annual_discounts } = useStepsStore();

  useEffect(() => {
    let discount  = 0;
    if(selected === 'annually') {
      if(vatExempt) {
        discount = annual_discounts.no_vat;
      } else {
        discount = annual_discounts.vat;
      }
    }
    setPlanDiscount(discount);
  }, [vatExempt, annual_discounts, selected]);

  useEffect(() => {
    const monthly = (vatExempt ? no_vat_plans : vat_plans).find(p => p.label === 'Monthly')?.price ?? 0;
    let annual = (vatExempt ? no_vat_plans : vat_plans).find(p => p.label === 'Annual')?.price ?? 0;
    if(planDisocunt > 0) {
      annual = annual - planDisocunt;
      if(annual < 0) {
        annual = 0;
      }
    }
    setPlanPrice({ monthly: monthly, annual: annual });
  }, [vatExempt , vat_plans, no_vat_plans, annual_discounts, planDisocunt]);

  useEffect(() => {
    const plans = vatExempt ? no_vat_plans : vat_plans;
    const variant = selected === 'monthly' ? 'Monthly' : 'Annual';
    setSelectedVariantId(plans.find(p => p.label === variant)?.id ?? null);
    setSubscriptionPrice(variant === 'Annual' ? planPrice.annual : planPrice.monthly);
  }, [selected, planPrice]);

  useEffect(() => {
    if (selectedVariantId) {
      const vatPlan = vat_plans.find(p => p.id === selectedVariantId);
      const noVatPlan = no_vat_plans.find(p => p.id === selectedVariantId);
      if (vatPlan) {
        setSelectedVariantId(vatPlan.id);
        setSelected(vatPlan.label === 'Monthly' ? 'monthly' : 'annually');
        setVatExempt(false);
      }
      if (noVatPlan) {
        setSelectedVariantId(noVatPlan.id);
        setSelected(noVatPlan.label === 'Monthly' ? 'monthly' : 'annually');
        setVatExempt(true);
      }
    } else {
      setVatExempt(newCustomerForm.vat_exempt ?? false);
    }
  }, [vat_plans, no_vat_plans, newCustomerForm ]);

  return (
    <div className="toggle-container">
      <div className='margin-top'>
        <label className='ncf-title'>Select your Subscription plan</label>
        <p className="step-explain">Our annual plan offers the best value over 12 months.</p>
      </div>

      <div className="toggle-switch">
        <input
          type="checkbox"
          id="paymentToggle"
          className="nav-button next-button"
          checked={selected === "annually"}
          onChange={(e) => handleToggle(e.target.checked ? "annually" : "monthly") }
        />

        <label htmlFor="paymentToggle" className="toggle-label">
          <span className="toggle-option left">Pay Monthly</span>
          <span className="toggle-option right">Pay Annually</span>
          <span className="toggle-slider" />
        </label>
      </div>

      <div className="payment-info">
        {selected === "monthly" ? (
          <p className="pricing-breakdown">
            <strong>Total</strong>
            <span className="product-title margin-top"><span>Monthly Care Service</span> <span><strong>£{planPrice.monthly.toFixed(2)}</strong></span></span>
            <div className="saving-wrap">
              <span>3-month minimum term.</span>
            </div>
          </p>
        ) : (
          <p className="pricing-breakdown">
            <strong>Total</strong>
            { planDisocunt > 0 ? <span className="save-tag">SAVE £{planDisocunt} <span>by paying annually<em>*</em></span></span> : ''}
            <span className="product-title"><span>Annual Care Service</span> <span>{ planDisocunt > 0 ? <s>£{(planDisocunt+planPrice.annual).toFixed(2)}</s> : ''} <strong>£{planPrice.annual.toFixed(2)}</strong></span></span>
            { planDisocunt > 0 ?
            <div className="saving-wrap">
              <span>*Year 1 saving, see terms and conditions <a href='https://careline.co.uk/pages/legal' target='_blank'>here</a>.</span>
            </div>
              :
            '' }
          </p>
        )}
         <p className="step-explain">Payment will be taken via a direct debit</p>
      </div>
    </div>
  );
}

export default PaymentOptionSelector;